import {BackendApi} from "../../../../../api/api.ts";
import {extractApiErrorMessage} from "../../../../../lib/apiErrors.ts";
import {ImportOutcome, ImportPreview, ImportResult} from "./types.ts";

function errorDetail(error: unknown): string {
    return extractApiErrorMessage(error) ?? (error as Error).message;
}

export async function commitImport(api: BackendApi, preview: ImportPreview): Promise<ImportResult> {
    const outcomes: ImportOutcome[] = [];

    for (const booking of preview.bookings) {
        if (booking.blocking || booking.body === null) continue;
        const label = `${booking.bookingDate} ${booking.auditReason}`.trim();
        try {
            await api.Partner__makeManualBooking(booking.body);
            outcomes.push({kind: "booking", label, status: "created", detail: null});
        } catch (error) {
            outcomes.push({kind: "booking", label, status: "failed", detail: errorDetail(error)});
        }
    }

    for (const asset of preview.assets) {
        if (asset.blocking || asset.body === null) continue;
        try {
            await api.Partner__createFixedAsset(asset.body);
            outcomes.push({kind: "asset", label: asset.name, status: "created", detail: null});
        } catch (error) {
            outcomes.push({kind: "asset", label: asset.name, status: "failed", detail: errorDetail(error)});
        }
    }

    return summarizeOutcomes(outcomes);
}

export function summarizeOutcomes(outcomes: ImportOutcome[]): ImportResult {
    const count = (kind: ImportOutcome["kind"], status: ImportOutcome["status"]) =>
        outcomes.filter((outcome) => outcome.kind === kind && outcome.status === status).length;

    return {
        outcomes,
        bookingsCreated: count("booking", "created"),
        bookingsFailed: count("booking", "failed"),
        assetsCreated: count("asset", "created"),
        assetsFailed: count("asset", "failed"),
    };
}
